import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import App from "views/App";
import Login from "views/Login";
import Search from "views/Search";
import { GoogleOAuthProvider } from "@react-oauth/google";

const mdTheme = createTheme({
  palette: {
    primary: {
      main: "#5628D2",
    },
  },
});

export default function RouterApp() {
  const [profile, setProfile] = useState(null);
  const login = <Login setProfile={setProfile} />;
  if (window.location.pathname === "/") {
    window.history.replaceState("", "", `summary${window.location.search}`);
  }
  let toRender = login;
  if (profile) {
    toRender = (
      <Routes>
        <Route path="/search" element={<Search profile={profile} setProfile={setProfile} />} />
        <Route path="/*" element={<App profile={profile} setProfile={setProfile} />} />
      </Routes>
    )
  }
  return (
    <BrowserRouter>
      <ThemeProvider theme={mdTheme}>
        <GoogleOAuthProvider
          clientId={process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID}
        >
          {Boolean(profile) ? toRender : login}
        </GoogleOAuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
